module.exports = __webpack_public_path__ + "static/media/image-laufrouten-2.18791929.jpg";